export const PROMOCODE = 'code';
export const BONUS_ID = 'bonus';
